import * as React from 'react';

import {useGetTeams} from '../graphql/hooks';

import {GraphQLSelect} from './graphql-select';

type Props = {
    name: string;
    placeholder: string;
    onChange: (newValue: any) => any;
    onClear?: () => void;
    menuPortalTarget?: HTMLElement;
    selectedId: string | null | undefined;
    isMulti: boolean;
    defaultsToFirstItem?: boolean;
    formatOptionLabel: (option: any) => React.ReactElement;
    tokenizedStyle?: string;
};

export const GraphQLSelectTeams = (props: Props) => {
    const {isLoading, teams} = useGetTeams();
    const teamOptions = teams.map((team) => ({
        value: team.id,
        label: team.name,
        isDisabled: false,
        numMembers: team.numUsers,
    }));

    return (
        <GraphQLSelect
            {...props}
            isLoading={isLoading}
            // @ts-expect-error
            openMenuOnFocus={true}
            closeMenuOnSelect={true}
            onChange={(selection) => {
                props.onChange(selection);
            }}
            onClear={props.onClear}
            models={teamOptions}
            selectedId={props.selectedId}
            valueKey='value'
            labelKey='label'
        />
    );
};
